import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const ExploreInfoDialog: React.FC = () => {
  const open = useUIStore((s) => s.exploreInfoDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('exploreInfoDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="Design Parameters Info"
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={500}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Rubber Angle Value
        </Typography>
        <Typography variant="body2">
          The rubber angle value determines the shape of the rubber profile.
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
          <li>
            <Typography variant="body2">
              <strong>Positive (+) Rubber Angle</strong> – Produces a regular rubber shape.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Negative (−) Rubber Angle</strong> – Produces an inverted rubber shape.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              <strong>Zero (±) Rubber Angle</strong> – Produces a U-shaped rubber profile.
            </Typography>
          </li>
        </Box>
      </Box>
    </DialogShell>
  );
};

export default ExploreInfoDialog;
